<template>
<v-select :box="!solo" :solo="solo" :hide-details="solo" :single-line="solo" v-model="selectedFuncType" :items="functypes" :rules="rules" prepend-inner-icon="lightbulb_outline" :label="label" :clearable="clearable">
  <template slot="item" slot-scope="data">
    <v-list-tile-avatar>
      <img :src="data.item.icon"></img>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>{{data.item.text}}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action style="min-width:12px">
      <v-checkbox color="primary" v-model="data.tile.props.value"></v-checkbox>
    </v-list-tile-action>
  </template>
</v-select>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'FuncTypeSelector',
  mixins: [UserAuth],
  props: {
    value: {
      type: String,
    },
    rules: {
      type: Array
    },
    label: {
      type: String
    },
    solo: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedFuncType: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    functypes() {
      return Object.keys(this.names).map(k => ({
        value: k,
        text: this.names[k],
        icon: this.$FuncTypeIcons[k]
      }))
    },
    names() {
      return {
        '11': this.$t('functype.temperature'),
        '12': this.$t('functype.lux'),
        '13': this.$t('functype.door'),
        '14': this.$t('functype.pir'),
        '15': this.$t('functype.humidity'),
        '16': this.$t('functype.gpio'),
        '17': this.$t('functype.smoke'),
        '18': this.$t('functype.co'),
        '19': this.$t('functype.co2'),
        '20': this.$t('functype.flood'),
        '21': this.$t('functype.glass'),
        '22': this.$t('functype.meter_switch'),
        '23': this.$t('functype.switch'),
        '24': this.$t('functype.dimmer'),
        '25': this.$t('functype.siren'),
        '26': this.$t('functype.curtain'),
        '27': this.$t('functype.remote'),
        '28': this.$t('functype.button'),
        '29': this.$t('functype.meter'),
        '30': this.$t('functype.meter_dimmer'),
        '31': this.$t('functype.doorlock'),
        '32': this.$t('functype.thermostat_fan'),
        '33': this.$t('functype.thermostat_mode'),
        '34': this.$t('functype.thermostat_temperature'),
        '35': this.$t('functype.control'),
        '36': this.$t('functype.valveswitch'),
        '37': this.$t('functype.air'),
        '40': this.$t('functype.uv'),
        '41': this.$t('functype.color_dimmer')
      };
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/FuncTypeSelector.vue